<template>
    <div>
        <a href="javascript:void(0);" @click="freeTry">免费体验</a>
    </div>
</template>
<script>
  import "@/assets/css/w-style.css"

  import FreeTry from "@/components/common/FreeTry.vue"
  export default {
    components:{
        FreeTry
    },
    name: 'FreeTryButton',
    data(){
        return {
            freeTryVisible: false,
        }
    },
    mounted() {
    },
    created(){
        
    },
    methods: {
        freeTry() {
            this.freeTryVisible = true
            this.$emit("getFreeTryVisible",this.freeTryVisible)

            this.$http.post('/backend/web/record', {//免费体验点击次数埋点
                pageName: 'FreeTryClick',
                contentName : '',
                extend2: 'CN'
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/FreeTryButton.vue